const AppSettings = {
    development: {
        enableNotifications: true,
        baseURL: 'http://localhost:5001/api/v1',
    },
    production: {
        enableNotifications: true,
        baseURL: '/api/v1',
    },
};

export default AppSettings[process.env.NODE_ENV || 'development'];
